import { useEffect, useRef } from 'react';

/** A new Lens selects Chat once when its pane is already open; it never opens the pane. */
export function useCreatedLensChatPreference({
  createdLensId,
  lensId,
  open,
  onHandled,
  selectChat,
}: {
  createdLensId?: string | null;
  lensId?: string | null;
  open: boolean;
  onHandled?: (lensId: string) => void;
  selectChat: () => void;
}) {
  const handled = useRef<string | null>(null);
  useEffect(() => {
    if (!createdLensId) {
      handled.current = null;
      return;
    }
    if (createdLensId !== lensId || handled.current === createdLensId) {
      return;
    }
    handled.current = createdLensId;
    if (open) {
      selectChat();
    }
    onHandled?.(createdLensId);
  }, [createdLensId, lensId, onHandled, open, selectChat]);
}
